import { Controller } from "@hotwired/stimulus"

// Live prices of the commissions step on the products with a monthly fractioning surcharge, invoice v2
// (FractioningComponent embedded in the step form). Same computation as
// MonthlyFractioning#payment_frequency_simulation: the surcharge applies to the base commissions only.
export default class extends Controller {
  static targets = ["amount", "simulated"]
  static values = { multiplier: Number, hiddenBaseCents: Number, hiddenOtherCents: Number }

  recompute() {
    let base = this.hiddenBaseCentsValue
    let other = this.hiddenOtherCentsValue
    this.amountTargets.forEach((input) => {
      const cents = Math.round((parseFloat(input.value) || 0) * 100)
      if (input.dataset.base === "true") base += cents
      else other += cents
    })

    const annual = base + other
    const surcharge = Math.round(base * (this.multiplierValue - 1))
    const amounts = {
      base: this.format(base),
      surcharge: `+${this.format(surcharge)}`,
      annual: this.format(annual),
      monthly: this.format(Math.round((annual + surcharge) / 12)),
      monthly_yearly: this.format(annual + surcharge),
    }

    this.simulatedTargets.forEach((element) => {
      element.textContent = amounts[element.dataset.simulationKey]
    })
  }

  // Mirror Money#format for EUR: "1 234,56 €".
  format(cents) {
    const [units, decimals] = (cents / 100).toFixed(2).split(".")
    return `${units.replace(/\B(?=(\d{3})+(?!\d))/g, " ")},${decimals} €`
  }
}
